<template>
  <div :class="containerClass">
    <ul role="tablist">
      <template v-for="(item, index) of steps">
        <li
          v-if="visible(item) && index != 4"
          :key="item.to"
          :class="getItemClass(item)"
          :style="item.style"
          role="tab"
          :aria-selected="isActive(item)"
          :aria-expanded="isActive(item)"
        >
          <span
            v-if="!isItemDisabled(item)"
            :class="linkClass({ isActive })"
            @click="onItemClick($event, item)"
            role="presentation"
          >
            <span v-if="currentStep > index" class="p-steps-number">
              <i
                class="pi pi-check p-primary-color"
                style="font-size: 1rem"
              ></i>
            </span>
            <span v-else class="p-steps-number">{{ index + 1 }}</span>

            <small v-if="showStepLabels" class="p-steps-title">
              {{ label(item) }}
            </small>
            <span v-else class="p-steps-title">&nbsp;</span>
          </span>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: "StepHeader",
  data() {
    return {
      showStepLabels: false,
    };
  },
  props: {
    currentStep: Number,
    steps: Array,
  },
  computed: {
    activeRoute() {
      return this.steps[this.currentStep].to;
    },
    containerClass() {
      return ["p-steps p-component", { "p-readonly": this.readonly }];
    },
  },
  mounted() {
    if (window.innerWidth < 768) {
      this.showStepLabels = false;
    } else {
      this.showStepLabels = true;
    }

    window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    myEventHandler() {
      if (window.innerWidth < 768) {
        this.showStepLabels = false;
      } else {
        this.showStepLabels = true;
      }
    },
    onItemClick(event, item) {
      if (this.disabled(item) || this.readonly) {
        // event.preventDefault();
        return;
      }
    },
    isActive(item) {
      return this.activeRoute === item.to || this.activeRoute === item.to + "/";
    },
    getItemClass(item) {
      return [
        "p-steps-item",
        item.class,
        {
          "p-highlight p-steps-current": this.isActive(item),
          "p-disabled": this.isItemDisabled(item),
        },
      ];
    },
    linkClass(routerProps) {
      return [
        "p-menuitem-link",
        {
          "router-link-active": routerProps && routerProps.isActive,
          "router-link-active-exact":
            this.exact && routerProps && routerProps.isExactActive,
        },
      ];
    },
    isItemDisabled(item) {
      return this.disabled(item) || (this.readonly && !this.isActive(item));
    },
    visible(item) {
      return typeof item.visible === "function"
        ? item.visible()
        : item.visible !== false;
    },
    disabled(item) {
      return typeof item.disabled === "function"
        ? item.disabled()
        : item.disabled;
    },
    label(item) {
      return typeof item.label === "function" ? item.label() : item.label;
    },
  },
};
</script>

<style scoped></style>

